import { Injectable } from '@angular/core';
import { global } from '../../../shared/global';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class schoolfeesincreaselist {

    constructor(private http: HttpClient) { }

    getSchoolFeesIncreaseList(data) {
        return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/getSchoolFeesIncreaseList', data, global.httpOptions);
    }
    // SchoolFeesIncreaseDetail(data) {
    //     return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/fillSchoolFeesIncreaseDetail', data, global.httpOptions);
    // }
    // updateSchoolFeesIncreaseDetail(data) {
    //     return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/updateSchoolFeesIncreaseDetail', data, global.httpOptions);
    // }
    // deleteSchoolFeesIncreaseDetail(data) {
    //     return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/deleteSchoolFeesIncreaseDetail', data, global.httpOptions);
    // }
    deleteSchoolFeesIncreasMaster(data) {
        return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/deleteSchoolFeesIncreasMaster', data, global.httpOptions);
    }
    
}